import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Base Group endpoints
  createBaseGroup: (data) => {
    return AxiosBusiness.post('base_group', data)
  },

  updateBaseGroup: (baseGroupId, data) => {
    return AxiosBusiness.put(`base_group/${baseGroupId}`, data)
  },

  deleteBaseGroup: (baseGroupId) => {
    return AxiosBusiness.delete(`base_group/${baseGroupId}`)
  },

  getBaseGroup: (baseGroupId) => {
    return AxiosBusiness.get(`base_group/${baseGroupId}`)
  },

  getBaseGroupsByCustomer: (customerId, params = {}) => {
    return AxiosBusiness.get(`base_group/customer/${customerId}`, { params })
  },

  // Base Preset endpoints
  createBasePreset: (data) => {
    return AxiosBusiness.post('base_preset', data)
  },

  updateBasePreset: (basePresetId, data) => {
    return AxiosBusiness.put(`base_preset/${basePresetId}`, data)
  },

  deleteBasePreset: (basePresetId) => {
    return AxiosBusiness.delete(`base_preset/${basePresetId}`)
  },

  getBasePreset: (basePresetId) => {
    return AxiosBusiness.get(`base_preset/${basePresetId}`)
  },

  getBasePresetsByGroup: (baseGroupId, params = {}) => {
    return AxiosBusiness.get(`base_preset/group/${baseGroupId}`, { params })
  },

  // Format Group endpoints
  createFormatGroup: (data) => {
    return AxiosBusiness.post('format_group', data)
  },

  updateFormatGroup: (formatGroupId, data) => {
    return AxiosBusiness.put(`format_group/${formatGroupId}`, data)
  },

  deleteFormatGroup: (formatGroupId) => {
    return AxiosBusiness.delete(`format_group/${formatGroupId}`)
  },

  getFormatGroup: (formatGroupId) => {
    return AxiosBusiness.get(`format_group/${formatGroupId}`)
  },

  getFormatGroupsByCustomer: (customerId, params = {}) => {
    return AxiosBusiness.get(`format_group/customer/${customerId}`, { params })
  },

  // Format Preset endpoints
  createFormatPreset: (data) => {
    return AxiosBusiness.post('format_preset', data)
  },

  updateFormatPreset: (formatPresetId, data) => {
    return AxiosBusiness.put(`format_preset/${formatPresetId}`, data)
  },

  deleteFormatPreset: (formatPresetId) => {
    return AxiosBusiness.delete(`format_preset/${formatPresetId}`)
  },

  getFormatPreset: (formatPresetId) => {
    return AxiosBusiness.get(`format_preset/${formatPresetId}`)
  },

  getFormatPresetsByGroup: (formatGroupId, params = {}) => {
    return AxiosBusiness.get(`format_preset/group/${formatGroupId}`, { params })
  },

  getFormatPresetsByBase: (basePresetId, params = {}) => {
    return AxiosBusiness.get(`format_preset/base/${basePresetId}`, { params })
  },

  // Billable Preset endpoints
  createBillablePreset: (data) => {
    return AxiosBusiness.post('billable_preset', data)
  },

  updateBillablePreset: (billablePresetId, data) => {
    return AxiosBusiness.put(`billable_preset/${billablePresetId}`, data)
  },

  deleteBillablePreset: (billablePresetId) => {
    return AxiosBusiness.delete(`billable_preset/${billablePresetId}`)
  },

  getBillablePreset: (billablePresetId) => {
    return AxiosBusiness.get(`billable_preset/${billablePresetId}`)
  },

  getBillablePresetsByFormat: (formatPresetId, params = {}) => {
    return AxiosBusiness.get(`billable_preset/format/${formatPresetId}`, { params })
  },
}
